import React, { useEffect } from 'react';
import { useTenantDiscovery } from './useTenantDiscovery';
import WaitingArea from './WaitingArea';

const continueSetupLink = process.env.REACT_APP_SIAA_SETUP_COMPLETE_REDIRECT;

export default function PostEnrollmentManager() {
    const { tenantDiscovery, progress } = useTenantDiscovery();
    const { data, fetching, error, success, expired, supportPending } = tenantDiscovery;
    useEffect(() => {
        if (data === true) {
            // redirect to the url
            window.location.href = continueSetupLink;
        }
    }, [data]);
    return (
        <div>
            <WaitingArea setupRequestReceived={data} expired={expired} supportPending={supportPending} progress={progress}/>
        </div>
    );
}